import styles from "./Navbar.module.css";
import logoHorizontal from "../../assets/navigation/logo-horizontal.png";
import logoVertical from "../../assets/navigation/logo-vertical.png";
import phoneIcon from "../../assets/navigation/phone-icon-colored.png";
import mailIcon from "../../assets/navigation/mail-icon-colored.png";
import menuIcon from "../../assets/navigation/menu-icon-colored.png";
import Button from "../UI/Button";
import DataContext from "../store/data-context";
import marketIcon from "../../assets/market-icon.png";

import { useContext, useEffect, useState } from "react";
import ContactRow from "../UI/ContactRow";
import LanguageChange from "../UI/LanguageChange";
import { Link, useNavigate } from "react-router-dom";
import NavigationContext from "../store/navigation-context";
import Navigation from "./Navigation";
import ToTopButton from "../UI/ToTopButton";

export default function Navbar() {
  const [atTop, setAtTop] = useState(true);
  const [isNavigating, setIsNavigating] = useState(false);
  const [toTopButton, setToTopButton] = useState(false);

  const navCtx = useContext(NavigationContext);
  const navigate = useNavigate();

  /**/

  const dataCtx = useContext(DataContext);

  const toMarketHandler = () => {

    setIsNavigating(false);
    if (
      window.location.hash !==
      `#/${dataCtx.lang.lang}/${dataCtx.pageData.market.title}`
    ) {
      navigate(`${dataCtx.lang.lang}/${dataCtx.pageData.market.title}`);
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (isNavigating) {
      setAtTop(false);
    } else {
      if (window.scrollY === 0) {
        if (
          !window.location.hash.includes("oglasnik") &&
          !window.location.hash.includes("anzeigenmarkt") &&
          !isNavigating
        ) {
          setAtTop(true);
        }
      }
    }
  }, [isNavigating]);

  useEffect(() => {
    if (
      !window.location.hash.includes("oglasnik") &&
      !window.location.hash.includes("anzeigenmarkt") &&
      !isNavigating
    ) {
      if (window.scrollY === 0) {
        setAtTop(true);
      }
    } else {
      setAtTop(false);
    }

    window.onscroll = () => {
      if (window.scrollY === 0) {
        if (
          !window.location.hash.includes("oglasnik") &&
          !window.location.hash.includes("anzeigenmarkt") &&
          !isNavigating
        ) {
          if (window.scrollY === 0) {
            setAtTop(true);
          }
        } else {
          setAtTop(false);
        }
      } else {
        setAtTop(false);
      }

      if (window.scrollY >= 2000) {
        setToTopButton(true);
      } else {
        setToTopButton(false);
      }
    };
  });

  useEffect(() => {
    const changeMobileView = () => {
      if (window.innerWidth <= 850 && navCtx.isMobile === false) {
        navCtx.setIsMobile(true);
      } else if (window.innerWidth > 850 && navCtx.isMobile === true) {
        navCtx.setIsMobile(false);
      }
    };

    window.addEventListener("resize", changeMobileView);

    return () => {
      window.removeEventListener("resize", changeMobileView);
    };
  }, [window.innerWidth]);

  return (
    <>
      {isNavigating && (
        <Navigation
          onClose={() => {
            setIsNavigating(false);
          }}
          dataCtx={dataCtx}
        />
      )}
      {toTopButton && <ToTopButton />}
      <main className={`${styles.main} ${styles[!atTop && `main-back`]}`}>
        <div className={styles.content}>
          <Link
            className={styles[`logo-container`]}
            to={`/${dataCtx.lang.lang}`}
            onClick={() => {
              window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
              setIsNavigating(false);
            }}
          >
            <img
              src={navCtx.isMobile ? logoVertical : logoHorizontal}
              alt="Logo."
              className={styles.logo}
            />
          </Link>

          {/* ACTIONS */}
          <div className={styles.actions}>
            <div className={styles.language}>
              <LanguageChange />
            </div>
            {/* CONTACTS */}
            <div className={styles.contacts}>
              <ContactRow icon={phoneIcon} info="+385 992406888" />
              <ContactRow icon={mailIcon} info="hogast@hogast.hr" />
            </div>
            {/*KONTAKT BUTTON*/}
            <div className={styles[`contact-button`]}>
              <Button
                onClick={() => {
                  navCtx.setIsContacting(true);
                }}
              >
                {dataCtx.pageData && dataCtx.pageData.contact.button}
              </Button>
            </div>
            {/* MARKET BUTTON */}
            <img
              src={marketIcon}
              alt="Menu."
              className={styles.market}
              onClick={toMarketHandler}
            />
            {/* MENU BUTTON */}
            <img
              src={menuIcon}
              alt="Menu."
              className={styles.menu}
              onClick={() => {
                setIsNavigating((prevValue) => !prevValue);
              }}
            />
          </div>
        </div>
      </main>
    </>
  );
}
